import { validateEstonianSsn } from './estonia/estonian-ssn'
import { validateLithuanianSsn } from './lithuania/lithuanian-ssn'
import { validateSwedishSsn } from './sweden/sweden-ssn'
import { validateLatviaSsn } from './latvia/latvia-ssn'
import appConfig from 'app.config'

export function validateSsn(value: string) {
	let isValid = true
	switch (appConfig.country) {
		case 'ee':
			isValid = validateEstonianSsn(value)
			return isValid

		case 'lt':
			const object = validateLithuanianSsn(value)
			isValid =
				typeof object === 'object' ? object.isValid : Boolean(object)
			return isValid

		case 'se':
			isValid = validateSwedishSsn(value)
			return isValid

		case 'lv':
			const obj = validateLatviaSsn(value)
			isValid = typeof obj === 'object' ? obj.isValid : Boolean(obj)
			return isValid

		default:
			return isValid
	}
}

export function formatSsn(newValue: string, previousValue: string) {
	switch (appConfig.country) {
		case 'lv':
			const maxLength = 12

			// Ignore changes when max length has been reached
			if (newValue.length > maxLength) return previousValue

			// Ignore format when format already been applied and user changes input
			if (newValue.includes('-') && newValue.length < maxLength)
				return newValue

			let val = newValue.replace(/\D/g, '')
			val = val.replace(/^(\d{6})(\d{1,2})/, '$1-$2')
			val = val.substring(0, 12)

			return val

		default:
			return newValue
	}
}
